<template>
  <v-container
    fluid
    fill-height
    grid-list-md
    class="background-grey"
  >
    <v-layout
      row
      justify-center
      align-center
    >
      <v-card
        width="100%"
        max-width="450"
      >
        <v-card
          color="grey lighten-4"
          text
        >
          <v-toolbar tile color="primary" dark>
            <v-toolbar-title>Select Your Ad Account</v-toolbar-title>
          </v-toolbar>
          <v-container
            fluid
            grid-list-md
          >
            <v-layout
              v-if="adAccounts.length"
              row
              wrap
            >
              <v-flex
                xs6
                class="d-flex"
                v-for="adAccount in adAccounts"
                :key="adAccount.id"
                @click="selectAdAccount(adAccount)"
              >
                <v-card
                  class="pointer d-flex"
                  ripple
                  :color="getAdaccountColor(adAccount.id)"
                >
                  <v-card-text>
                    <div class="body-2">
                      {{ adAccount.name }}
                    </div>
                    <div>{{ adAccount.id.slice(4) }}</div>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
            <v-layout
              v-else
            >
              <v-flex sx12>
                <v-card>
                  <v-card-text class="text-md-center">
                    We could not find any Facebook ad accounts
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
        <v-card
          color="grey lighten-4"
          text
        >
          <v-toolbar tile color="primary" dark>
            <v-toolbar-title>Select Your Page</v-toolbar-title>
          </v-toolbar>
          <v-container
            fluid
            grid-list-md
          >
            <v-layout
              v-if="accounts.length"
              row
              wrap
            >
              <v-flex
                xs6
                class="d-flex"
                v-for="account in accounts"
                :key="account.id"
                @click="selectAccount(account)"
              >
                <v-card
                  class="pointer d-flex"
                  ripple
                  :color="getColor(account.id)"
                >
                  <v-card-text>
                    <div class="body-2">
                      {{ account.name }}
                    </div>
                    <div>{{ account.id.slice(4) }}</div>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
            <v-layout
              v-else
            >
              <v-flex sx12>
                <v-card>
                  <v-card-text class="text-md-center">
                    We could not find any Facebook pages
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
        <v-layout
          row
          align-center
          justify-space-between
        >
          <v-btn
            text
            color="primary"
            @click="cancel"
          >
            Cancel
          </v-btn>
          <v-btn
            text
            color="primary"
            @click="goToPreviousRoute"
          >
            Ok
          </v-btn>
        </v-layout>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
  import lodash from 'lodash'
  export default {
    name: 'AdminSetupAccountsDialog',
    computed: {
      user () {
        return this.$store.getters.getCurrentUser
      },
      selectedAdvertiser () {
        if (!this.user) return false
        const advertisers = this.$store.getters.getAdvertisers
        return advertisers.find(a => a.id === this.user.firebaseAccount.selectedAdvertiser)
      },
      accounts () {
        if (!this.user) return []
        return this.user.accounts
      },
      adAccounts () {
        if (!this.user) return []
        return this.user.adAccounts
      }
    },
    methods: {
      selectAccount (account) {
        const copy = lodash.cloneDeep(this.selectedAdvertiser)
        copy.data.fb_page_id = account.id
        this.selectedAccount = true
        this.$store.dispatch('updateAdvertiser', copy)
      },
      selectAdAccount (adAccount) {
        const copy = lodash.cloneDeep(this.selectedAdvertiser)
        copy.data.ad_account = adAccount.id
        this.selectedAdaccount = true
        this.$store.dispatch('updateAdvertiser', copy)
      },
      getColor (id) {
        if (this.selectedAdvertiser && this.selectedAdvertiser.data.fb_page_id === id) return 'green lighten-3'
        return ''
      },
      getAdaccountColor (id) {
        if (this.selectedAdvertiser && this.selectedAdvertiser.data.ad_account === id) return 'green lighten-3'
        return ''
      },
      accountsValidation () {
        return !!(
          this.selectedAdvertiser &&
          this.selectedAdvertiser.data.fb_page_id &&
          this.selectedAdvertiser.data.ad_account
        )
      },
      goToPreviousRoute () {
        if (this.accountsValidation()) {
          const copy = lodash.cloneDeep(this.selectedAdvertiser)
          copy.data.setupMode.status = false
          copy.data.setupMode.items[2].tasks[2].completed = true
          this.$store.dispatch('updateAdvertiser', copy)
          const notification = {
            type: 'success',
            message: ['Congrats! You can now launch an ad campaign.']
          }
          this.$store.dispatch('showNotification', notification)
        }
        this.$router.go(-1)
      },
      cancel () {
        const copy = lodash.cloneDeep(this.selectedAdvertiser)
        copy.data.ad_account = ""
        copy.data.fb_page_id = ""
        this.$store.dispatch('updateAdvertiser', copy)
        this.$router.go(-1)
      }
    }
  }
</script>

<style scoped>

</style>
